import React from "react";
import { getImageLink, getImageAltText } from "../../../utils/images";

const Image = ({ imageNode, className }) => {
    return <img src={getImageLink(imageNode)} alt={getImageAltText(imageNode)} className={className} />;
};

export default Image;
